
import { ChartCard } from "../chart-utils/ChartCard";
import { MonthlyLineChart } from "./monthly/MonthlyLineChart";

interface MonthlyRevenueChartProps {
  data: { month: string; amount: number; }[];
}

export const MonthlyRevenueChart = ({ data }: MonthlyRevenueChartProps) => {
  return (
    <ChartCard
      title="Revenue Over Time"
      description="Monthly revenue trends"
    >
      <MonthlyLineChart data={data} />
    </ChartCard>
  );
};
